import CastAPIManager from './cast_api_manager';
import SessionManager from './session_manager';
import MessageManager from './message_manager';

class ChromecastManager {
  constructor() {
    this._promise = null;
  }

  init() {
    this._promise = this._promise || CastAPIManager.init()
      .then(SessionManager.init.bind(SessionManager))
      .then(MessageManager.init.bind(MessageManager));

    return this._promise;
  }

  onSessionChanged(callback) {
    SessionManager.addSessionChangedListener(callback);
  }

  sendMessage(subject, payload) {
    return MessageManager.sendMessage({ subject, payload });
  }
}

export default new ChromecastManager();



// WEBPACK FOOTER //
// ./src/services/chromecast/chromecast_manager.js